export default __webpack_public_path__ + "aa935b66ae68067d4eec05165faf0dee.png";